import { useNavigate } from 'react-router-dom';
import { StreamForm } from '@/components/admin/stream-form';
import { AdminLayout } from '@/components/layouts/admin-layout';

export default function AdminNewStreamPage() {
  const navigate = useNavigate();
  return (
    <AdminLayout>
      <StreamForm
        onSuccess={(stream) => {
          navigate(`/admin/streams/${stream.id}`);
        }}
      />
    </AdminLayout>
  );
}
